import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  rotateWarning: {
    width: "100%",
    height: "100%",
    background: theme.colors.text0,
    zIndex: theme.zIndex.dialog + 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    textAlign: "center",
    padding: "0 16px",
    boxSizing: "border-box",
  },
  rotate: {
    marginTop: 16,
  },
  contentIcon: {
    position: "relative",
    margin: 20,
  },
  arrowRightToLeft: {
    "&.runRightToLeft": {
      animation: "$rotateRightToLeft 2s ease-in-out infinite",
    },
  },
  "@keyframes rotateRightToLeft": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "50%": {
      transform: "rotate(-90deg)",
    },
    "100%": {
      transform: "rotate(-90deg)",
    },
  },
}));
